/** Just a really long interval since we only want reload on demand */
export const dedupingInterval = 100000000 as const;
